const locales = require('../../config/i18n');
const clean = (value) => String(value || '').replace(/^\/+|\/+$/g, '');
const normalizePath = (value) =>
  clean(value) ? '/' + clean(value) + '/' : '/';

function getLanguageTargets({
  locale,
  pathname = '/',
  alternateLanguages = [],
  availablePaths = new Set(),
}) {
  const current = locales[locale] ? locale : 'en-gb';
  const prefix = '/' + locales[current].path;
  const currentPath = normalizePath(pathname);
  const home = pathname === '/' || currentPath === prefix + '/';
  const blogDetail =
    currentPath.startsWith(prefix + '/blog/') &&
    currentPath !== prefix + '/blog/';
  const integrationDetail = currentPath.startsWith(prefix + '/integration/');
  const alternates = new Map(
    (alternateLanguages || []).map((alt) => [alt.lang, clean(alt.uid)])
  );
  return Object.keys(locales)
    .filter((lang) => lang !== current)
    .flatMap((lang) => {
      const targetPrefix = '/' + locales[lang].path;
      const uid = alternates.get(lang);
      let target;
      if (home) target = targetPrefix + '/';
      else if (uid) {
        const section = blogDetail
          ? 'blog/'
          : integrationDetail
            ? 'integration/'
            : '';
        target =
          targetPrefix +
          '/' +
          (section && !uid.startsWith(section) ? section : '') +
          uid +
          '/';
      } else {
        // Identical slugs alone do not prove that blog articles are translations.
        if (blogDetail || !currentPath.startsWith(prefix + '/')) return [];
        target = targetPrefix + currentPath.slice(prefix.length);
      }
      return availablePaths.has(normalizePath(target))
        ? [{ lang, to: target }]
        : [];
    });
}
module.exports = { getLanguageTargets, normalizePath };
